module.exports = __webpack_public_path__ + "static/info-15@2x.b0341168.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mini_portal/Organization/info-15@2x.png
// module id = 837
// module chunks = 153456355441848